import { render, staticRenderFns } from "./gastrozabota_calendar.vue?vue&type=template&id=4775bfdf&scoped=true&"
import script from "./gastrozabota_calendar.vue?vue&type=script&lang=js&"
export * from "./gastrozabota_calendar.vue?vue&type=script&lang=js&"
import style0 from "./gastrozabota_calendar.vue?vue&type=style&index=0&id=4775bfdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4775bfdf",
  null
  
)

export default component.exports